var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6655 1V5C10.6655 5.26522 10.7709 5.51957 10.9584 5.70711C11.146 5.89464 11.4003 6 11.6655 6H15.6655M10.6655 1H3.66553C3.13509 1 2.62639 1.21071 2.25131 1.58579C1.87624 1.96086 1.66553 2.46957 1.66553 3V17C1.66553 17.5304 1.87624 18.0391 2.25131 18.4142C2.62639 18.7893 3.13509 19 3.66553 19H13.6655C14.196 19 14.7047 18.7893 15.0797 18.4142C15.4548 18.0391 15.6655 17.5304 15.6655 17V6M10.6655 1L15.6655 6M5.66553 7H6.66553M5.66553 11H11.6655M5.66553 15H11.6655",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesIcon);
export default __webpack_public_path__ + "static/media/pages-icon.b98e3368533ac74b5d8db30b518f3f41.svg";
export { ForwardRef as ReactComponent };